<ng-container *ngIf="!edit; else editing">
    <kw-fill-layer-renderer [fillClass]="gridCell.fillClass" [fillColor]="gridCell.fillColor"></kw-fill-layer-renderer>
    <div class="content-layer">
        <div class="reverseable-container name-image">
            <div class="image-container">
                <img src="{{gridCell?.imgSrc}}">
            </div>
            <!-- <kw-content-element-renderer contentName="Author" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer"></kw-content-element-renderer> -->
        </div>
        <div class="reverseable-container detail">
            <div class="content-element-group main">
                <div class="blog-summary">
                    Latest Blog
                </div>
                <div class="blog-title">
                    <kw-content-element-renderer contentName="Header" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                </div>
            </div>
            <div class="content-element-group inline caption">
                <div class="inline-end-link">Read</div>
            </div>
        </div>
    </div>
</ng-container>
<ng-template #editing>
    <ng-container *ngIf="gridCell.status === 'Initial Draft';else inProgress">
        <kw-fill-layer-renderer [fillClass]="gridCell.fillClass" [fillColor]="gridCell.fillColor"></kw-fill-layer-renderer>
        <div class="content-layer">
            <div class="reverseable-container name-image">
                <div class="image-container">
                    <img src="{{gridCell?.imgSrc}}">
                </div>
                <!-- <kw-content-element-renderer contentName="Author" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer"></kw-content-element-renderer> -->
            </div>
            <div class="reverseable-container detail">
                <div class="content-element-group main">
                    <div class="blog-summary">
                        Latest Blog
                    </div>
                    <div class="blog-title">
                        <kw-content-element-renderer contentName="Header" [contentElements]="gridCell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                    </div>
                </div>
                <div class="content-element-group inline caption">
                    <div class="inline-end-link">Read</div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-template #inProgress>
        <kw-edit-placeholder-renderer [gridCell]="gridCell" (createGridCellContent)="createContent($event)"></kw-edit-placeholder-renderer>
    </ng-template>
</ng-template>

